/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useDeviceDetect } from 'hooks';
import DesktopInvoiceView from './DesktopInvoiceView';
import MobileInvoiceView from './MobileInvoiceView';

function Invoices() {
  const { isMobile } = useDeviceDetect();

  return <Box sx={{ flexGrow: 1 }}>{isMobile ? <MobileInvoiceView /> : <DesktopInvoiceView />}</Box>;
}

export default Invoices;
